import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// EN
import action from '../assets/locales/en/action.json';
import common from '../assets/locales/en/common.json';
import header from '../assets/locales/en/header.json';
import issue from '../assets/locales/en/issue.json';
import settings from '../assets/locales/en/settings.json';
import table from '../assets/locales/en/table.json';

// DE
import actionDe from '../assets/locales/de/action.json';
import commonDe from '../assets/locales/de/common.json';
import headerDe from '../assets/locales/de/header.json';
import issueDe from '../assets/locales/de/issue.json';
import settingsDe from '../assets/locales/de/settings.json';
import tableDe from '../assets/locales/de/table.json';

// FR
import actionFr from '../assets/locales/fr/action.json';
import commonFr from '../assets/locales/fr/common.json';
import headerFr from '../assets/locales/fr/header.json';
import issueFr from '../assets/locales/fr/issue.json';
import settingsFr from '../assets/locales/fr/settings.json';
import tableFr from '../assets/locales/fr/table.json';

// ES
import actionEs from '../assets/locales/es/action.json';
import commonEs from '../assets/locales/es/common.json';
import headerEs from '../assets/locales/es/header.json';
import issueEs from '../assets/locales/es/issue.json';
import settingsEs from '../assets/locales/es/settings.json';
import tableEs from '../assets/locales/es/table.json';

// JA
import actionJa from '../assets/locales/ja/action.json';
import commonJa from '../assets/locales/ja/common.json';
import headerJa from '../assets/locales/ja/header.json';
import issueJa from '../assets/locales/ja/issue.json';
import settingsJa from '../assets/locales/ja/settings.json';
import tableJa from '../assets/locales/ja/table.json';

// PT
import actionPt from '../assets/locales/pt/action.json';
import commonPt from '../assets/locales/pt/common.json';
import headerPt from '../assets/locales/pt/header.json';
import issuePt from '../assets/locales/pt/issue.json';
import settingsPt from '../assets/locales/pt/settings.json';
import tablePt from '../assets/locales/pt/table.json';

// ZH
import actionZh from '../assets/locales/zh/action.json';
import commonZh from '../assets/locales/zh/common.json';
import headerZh from '../assets/locales/zh/header.json';
import issueZh from '../assets/locales/zh/issue.json';
import settingsZh from '../assets/locales/zh/settings.json';
import tableZh from '../assets/locales/zh/table.json';

// IT
import actionIt from '../assets/locales/it/action.json';
import commonIt from '../assets/locales/it/common.json';
import headerIt from '../assets/locales/it/header.json';
import issueIt from '../assets/locales/it/issue.json';
import settingsIt from '../assets/locales/it/settings.json';
import tableIt from '../assets/locales/it/table.json';

// NL
import actionNl from '../assets/locales/nl/action.json';
import commonNl from '../assets/locales/nl/common.json';
import headerNl from '../assets/locales/nl/header.json';
import issueNl from '../assets/locales/nl/issue.json';
import settingsNl from '../assets/locales/nl/settings.json';
import tableNl from '../assets/locales/nl/table.json';

export const defaultNS = 'common';
export const defaultLanguage = 'en';

// TODO: proper loading of all the json files (on demand)

export const resources = {
  en: {
    common,
    header,
    issue,
    settings,
    action,
    table,
  },
  de: {
    common: commonDe,
    header: headerDe,
    issue: issueDe,
    settings: settingsDe,
    action: actionDe,
    table: tableDe,
  },
  fr: {
    common: commonFr,
    header: headerFr,
    issue: issueFr,
    settings: settingsFr,
    action: actionFr,
    table: tableFr,
  },
  es: {
    common: commonEs,
    header: headerEs,
    issue: issueEs,
    settings: settingsEs,
    action: actionEs,
    table: tableEs,
  },
  ja: {
    common: commonJa,
    header: headerJa,
    issue: issueJa,
    settings: settingsJa,
    action: actionJa,
    table: tableJa,
  },
  pt: {
    common: commonPt,
    header: headerPt,
    issue: issuePt,
    settings: settingsPt,
    action: actionPt,
    table: tablePt,
  },
  zh: {
    common: commonZh,
    header: headerZh,
    issue: issueZh,
    settings: settingsZh,
    action: actionZh,
    table: tableZh,
  },
  it: {
    common: commonIt,
    header: headerIt,
    issue: issueIt,
    settings: settingsIt,
    action: actionIt,
    table: tableIt,
  },
  nl: {
    common: commonNl,
    header: headerNl,
    issue: issueNl,
    settings: settingsNl,
    action: actionNl,
    table: tableNl,
  },
} as const;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: defaultLanguage,
    fallbackLng: defaultLanguage,
    defaultNS,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
